<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
    content-class="deposit-withdraw-popup marketingPopup">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-decoration-none" v-bind="attrs" v-on="on">Internal Transfer</span>
    </template>
    <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Internal Transfer
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        Transfer Money From Here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>From Trading Account*</legend>
              <v-select v-model="from_trading_account_no" solo :items="fromAccountOptions" item-text="text"
                item-value="value" append-icon="mdi-chevron-down" label="Click to Select" class="custom-select"
                hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>To Trading Account*</legend>
              <v-select v-model="to_trading_account_no" solo :items="toAccountOptions" item-text="text"
                item-value="value" append-icon="mdi-chevron-down" label="Select Your Acc." class="custom-select"
                hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Amount*</legend>
              <v-text-field v-model="amount" label="USD" single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="submitForm" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">Confirm</v-btn>
            <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      dialogDeposit: false,
      from_trading_account_no: null,
      to_trading_account_no: null,
      amount: null,
      client_account_id: null
    };
  },
  computed: {
    ...mapState("reguserdetails", ["tradingAcc"]),
    fromAccountOptions() {
      return this.tradingAcc.filter(acc => acc.value !== this.to_trading_account_no);
    },
    toAccountOptions() {
      return this.tradingAcc.filter(acc => acc.value !== this.from_trading_account_no);
    }
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS, REGISTERUSERDETAILS__ACTIONS.CREATECLIENTINTX]),
    submitForm() {
      const formData = {
        client_account_id: this.client_account_id,
        from_trading_account_no: this.from_trading_account_no,
        to_trading_account_no: this.to_trading_account_no,
        amount: this.amount
      };
      this[REGISTERUSERDETAILS__ACTIONS.CREATECLIENTINTX](formData)
      this.dialogDeposit = false;
      this.from_trading_account_no = null;
      this.to_trading_account_no = null;
      this.amount = '';
    }
  },
  async mounted() {
    this.client_account_id = this.$route.params.id;
    await this[REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS](this.$route.params.id);
  },
};
</script>